var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import LoginHtml from './loginHtml';
import Tool from '../../common/tool';
import FadeEffect from '../../common/fadeEffect';
import WmRequest from '../../common/request';
import Config from '../../common/config';
import LoginMethodList from './loginMethodList';
var Login = /** @class */ (function () {
    function Login(jumpToUrl) {
        var _a, _b;
        // 选择的登录方式，wechat:微信，phone:手机号，email:邮箱
        this.loginFlag = "wechat";
        document.getElementsByTagName("body")[0].insertAdjacentHTML("beforeend", LoginHtml.loginStr);
        this.loginDom = document.getElementById("wmLogin-container");
        this.tabList = (_a = this.loginDom.querySelector(".login-container-tab")) === null || _a === void 0 ? void 0 : _a.getElementsByTagName('li');
        this.bottomList = (_b = this.loginDom.querySelector(".login-bottom")) === null || _b === void 0 ? void 0 : _b.getElementsByTagName('li');
        if (jumpToUrl) {
            this.loginMethod = new LoginMethodList(jumpToUrl, this.getWechatQrcode.bind(this));
        }
        else {
            this.loginMethod = new LoginMethodList(undefined, this.getWechatQrcode.bind(this));
        }
        this.fullUrl = window.location.href;
        this.wmRequest = new WmRequest();
        this.init();
    }
    Login.prototype.init = function () {
        this.showLastLogin();
        // this.topTab();
        this.bottomTab();
        this.defaultEvent();
    };
    Login.prototype.showLastLogin = function () {
        // 上次登录：1.微信 2.手机 3.邮箱 4.QQ
        var lastLoginLabels = Tool.$_selectAll(this.loginDom, '.last-login-method');
        lastLoginLabels.forEach(function (item) { return item.classList.remove('show'); });
        var lastLoginLabel;
        switch (Number(lastLoginMethod)) {
            case 1:
                lastLoginLabel = Tool.$_select(this.loginDom, '.last-login-wx');
                break;
            case 2:
                lastLoginLabel = Tool.$_select(this.loginDom, '.last-login-phone');
                break;
            case 3:
                lastLoginLabel = Tool.$_select(this.loginDom, '.last-login-email');
                break;
            case 4:
                lastLoginLabel = Tool.$_select(this.loginDom, '.last-login-qq');
                break;
        }
        lastLoginLabel === null || lastLoginLabel === void 0 ? void 0 : lastLoginLabel.classList.add('show');
    };
    Login.prototype.defaultEvent = function () {
        var that = this;
        that.getWechatQrcode();
        var closeBtn = Tool.$_select(that.loginDom, '.dialog-close');
        // 隐藏关闭按钮，引导用户强制登录
        if (this.fullUrl == '/purchasePay' ||
            this.fullUrl == '/ExchangeCode' ||
            this.fullUrl == '/exchange-center' ||
            this.fullUrl.includes('/buy?g_id=') ||
            this.fullUrl.includes('/user')) {
            closeBtn.classList.add('hide');
        }
        // 关闭登录弹窗
        closeBtn.addEventListener("click", function () {
            var search = window.location.search;
            if (search.indexOf('useCoupon=1') != -1) {
                var newUrl = window.location.href.replace(search, '');
                history.pushState(null, '', newUrl);
            }
            FadeEffect.fadeOut(that.loginDom);
            setTimeout(function () {
                that.loginDom.remove();
                that.loginFlag = 'close';
                that.loginMethod.showLoginBox(that.loginFlag);
            }, 500);
        });
    };
    // 获取微信登录二维码
    Login.prototype.getWechatQrcode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var that, qrcodeDom;
            return __generator(this, function (_a) {
                that = this;
                qrcodeDom = Tool.$_select(that.loginDom, ".login-qrcode .qrcode");
                that.wmRequest.ajax({
                    type: 'GET',
                    url: Config.WM_LOGIN_GETWECHATCODE,
                    data: {}
                }).then(function (res) {
                    if (res.code == 200) {
                        // 显示二维码
                        Tool.$_select(that.loginDom, ".login-qrcode .loading").classList.remove('show');
                        Tool.$_select(that.loginDom, ".login-qrcode span").style.display = 'none';
                        qrcodeDom.classList.add('show');
                        qrcodeDom.setAttribute("src", "https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=".concat(res.qr_code));
                        return true;
                    }
                    else {
                        alert("获取二维码失败");
                        return false;
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    // // 顶部tab栏切换，微信手机号
    // topTab() {
    //   for (let i = 0; i < this.tabList.length; i++) {
    //     let that = this;
    //     that.tabList[i].addEventListener("click", function () {
    //       for (let j = 0; j < that.tabList.length; j++) {
    //         that.tabList[j].classList.remove("active");
    //       }
    //       that.tabList[i].classList.add("active");
    //       that.loginFlag = i == 0 ? "wechat" : "phone";
    //       that.loginMethod.showLoginBox(that.loginFlag);
    //     })
    //   }
    // }
    //底部按钮点击
    Login.prototype.bottomTab = function () {
        var that = this;
        // 微信登录
        that.bottomList[0].addEventListener("click", function () {
            that.loginMethod.showLoginBox('wechat');
        });
        // 手机号登录
        that.bottomList[1].addEventListener("click", function () {
            that.loginMethod.showLoginBox('phone');
        });
        //qq登录
        that.bottomList[2].addEventListener("click", function () {
            that.loginMethod.qqLogin();
        });
        // 切换邮箱登录
        that.bottomList[3].addEventListener("click", function () {
            that.loginFlag = "email";
            that.loginMethod.showLoginBox('email');
        });
    };
    return Login;
}());
export default Login;
